import React from 'react';
import { Modal } from 'react-bootstrap';
import {
    Elements,
    StripeProvider,
    CardElement,
    injectStripe
} from 'react-stripe-elements';

import api from '../../utils/api';

import stripeLogo from '../../assets/img/stripe/solid-dark/powered_by_stripe@2x.png';

const style = {
    base: {
        fontFamily: '"Open Sans"',
        color: '#555',
        lineHeight: 1.42857143,
        '::placeholder': {
            color: '#999',
        }
    }
};

const options = {
    fonts: [
        {
            cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans'
        }
    ]
};

class Form extends React.Component {

    static defaultProps = {
        size: 'large'
    };

    constructor(props) {

        super(props);

        let billingName = this.props.stripeCustomer.description || '';
        let billingEmail = this.props.stripeCustomer.email || '';

        if (this.props.stripeCustomer.sources.data[0]) {
            billingName =  this.props.stripeCustomer.sources.data[0].owner.name || billingName;
            billingEmail =  this.props.stripeCustomer.sources.data[0].owner.email || billingEmail;
        }

        this.state = {
            billingName,
            billingEmail,
            cardReady: false
        };
    }

    onChangeBillingName = ({ currentTarget: { value: billingName } }) => {

        this.setState({ billingName });
    };

    onChangeBillingEmail = ({ currentTarget: { value: billingEmail } }) => {

        this.setState({ billingEmail });
    };

    onChangeCard = ({ empty, complete: cardReady, error }) => {

        this.setState({ cardReady });
    };

    onSubmit = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            const { billingName, billingEmail } = this.state;

            this.props.stripe.createSource({
                type: 'card',
                usage: 'reusable',
                owner: {
                    name: billingName,
                    email: billingEmail
                }
            })
                .then(({ source: { id: sourceId } }) => {

                    return api.updateCard({ sourceId, billingName, billingEmail });
                })
                .then(({ data: stripeCustomer }) => {

                    this.props.changeStripeCustomer(stripeCustomer, () => {

                        this.props.changeCover(false, this.props.afterSubmit);
                    });
                });
        });
    };

    render() {

        const col = this.props.size === 'small' ? '12' : '6';

        return (
            <form onSubmit={this.onSubmit}>

                <div className="row">

                    <div className={`col-lg-${col}`}>

                        <div className="form-group">
                            <label htmlFor="billing-name">
                                Billing Name
                            </label>
                            <input
                                type="text"
                                id="billing-name"
                                name="billing-name"
                                className="form-control"
                                value={this.state.billingName}
                                onChange={this.onChangeBillingName}
                                placeholder="Full name on credit card"
                                required
                            />
                        </div>

                    </div>

                    <div className={`col-lg-${col}`}>
                        <div className="form-group">
                            <label htmlFor="billing-email">
                                Billing Email
                            </label>
                            <input
                                type="email"
                                id="billing-email"
                                name="billing-email"
                                className="form-control"
                                value={this.state.billingEmail}
                                onChange={this.onChangeBillingEmail}
                                placeholder="Email address for billing"
                                required
                            />
                        </div>
                    </div>

                </div>

                <div className="form-group">
                    <div className="clearfix">
                        <label htmlFor="card-number">
                            Credit Card
                        </label>
                        <a className="pull-right" href="https://stripe.com" target="_blank">
                            <img
                                alt="Powered by Stripe"
                                src={stripeLogo}
                                style={{width: 75}}
                            />
                        </a>
                    </div>
                    <CardElement
                        id="card-number"
                        className="form-control"
                        style={style}
                        onChange={this.onChangeCard}
                    />
                </div>

                <div className="form-group">
                    <button
                        disabled={!this.state.billingName || !this.state.billingEmail || !this.props.stripe || !this.state.cardReady}
                        type="submit"
                        className="btn btn-success pull-right"
                        style={{marginBottom: 15}}
                    >
                        Update Billing Info
                    </button>
                </div>
            </form>
        );
    }
}

const StripeForm = injectStripe(Form);


class BillingInfo extends React.Component {

    static description(stripeCustomer) {

        const [ source ] = stripeCustomer.sources.data;
        let current = source ? `Card on file: ${source.card.brand} ending in ${source.card.last4}` : 'No card currently on file';

        if (source) {
            let month = `${source.card.exp_month}`;
            if (month.length === 1) {
                month = `0${month}`;
            }

            current+= ` (exp. ${month}/${source.card.exp_year})`;
        }

        return (
            <div className="well">{current}</div>
        );
    }

    render() {

        return (
            <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}>
                <Elements {...options}>
                    <StripeForm{...this.props} />
                </Elements>
            </StripeProvider>
        );
    }
}

export default BillingInfo;



// WEBPACK FOOTER //
// ./src/components/_global/BillingInfo.jsx